<!DOCTYPE html>
<div class="close-area" (click)="closeDialog()"></div>
<div class="total-div" [ngClass]="
    selectedTriggerData?.jackpot_name === 'EuroMillions'
      ? 'blue-section'
      : selectedTriggerData?.jackpot_name === 'Lotto'
      ? 'red-section'
      : 'brown-section'
  ">
  <div class="main-logo">
    <img src="{{ selectedTriggerData?.jackpot_image }}" alt="" class="logo" />
  </div>
  <div class="container">
    <div class="msg">
      <p>
        {{ 'jackpot-trigger.change_trigger_1' | translate}}<br />
        {{ 'jackpot-trigger.change_trigger'| translate }}
      </p>
    </div>
    <div class="tip">
      <p>{{'jackpot-trigger.change_bigger' | translate }}</p>
    </div>
  </div>
  <div class="slider">
    <p>{{currencySymbol}}{{ centerValue }}{{ unit }}</p>

    <div class="main-slider">
      <div class="sub-slider">
        <ion-range class="" aria-label="Custom range" [min]="sliderMin" [max]="sliderMax" [value]="centerValue"
          [pin]="false" [ticks]="false" [snaps]="false" [step]="sliderStep" (ionChange)="onSliderChange($event)"
          (ionTouchEnd)="onSliderRelease()">
        </ion-range>
      </div>

    </div>
    <div class="slide-info">
      <span>{{'jackpot-trigger.Occasionally' | translate }}</span>
      <span>{{'jackpot-trigger.Popular' | translate }}</span>
      <span>{{'jackpot-trigger.Infrequent' | translate }}</span>
    </div>

  </div>
  <div class="btn_div">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fbubico_400x400.webp?alt=media"
      alt="">
  </div>
  <div class="btn">
    <button class="act-btn" [disabled]="isConfirmButtonDisabled"
      [ngClass]="{'disabled-button': isConfirmButtonDisabled}"
      (click)="update(centerValue+unit)">{{'jackpot-trigger.update_threshold' | translate }}</button>
    <p
      class="sub-link"
      [class.disabled]="isDeactivating"
      [attr.aria-disabled]="isDeactivating"
      (click)="!isDeactivating && closeBox()"
    >{{'jackpot-trigger.Turn_off' | translate }}</p>
  </div>
</div>